import type { AppRouteModule } from '/@/router/types'

import { LAYOUT } from '/@/router/constant'
import { t } from '/@/hooks/web/useI18n'

const tools: AppRouteModule = {
    path: '/tools',
    name: 'Tools',
    component: LAYOUT,
    redirect: '/tools/database',
    meta: {
        orderNo: 2001,
        icon: 'carbon:tools',
        title: t('routes.demo.tools.moduleName'),
    },
    tag: {
        dot: true,
    },
    children: [
        {
            path: 'file',
            name: 'FileTools',
            meta: {
                title: t('routes.demo.tools.file'),
                icon: 'material-symbols:attach-file',
            },
            component: () => import('/@/views/demo/tools/file/index.vue'),
        },
        {
            path: 'form',
            name: 'FormTools',
            meta: {
                title: t('routes.demo.tools.form'),
                icon: 'fluent:form-multiple-20-regular',
            },
            component: () => import('/@/views/demo/tools/form/index.vue'),
        },
        {
            path: 'process',
            name: 'ProcessTools',
            meta: {
                title: t('routes.demo.tools.process'),
                icon: 'fluent-mdl2:server-processes',
            },
            component: () => import('/@/views/demo/tools/process/index.vue'),
        },
        {
            path: 'database',
            name: 'DatabaseTools',
            meta: {
                title: t('routes.demo.tools.database'),
                icon: 'mdi:database-lock-outline',
            },
            component: () => import('/@/views/demo/tools/database/index.vue'),
            tag: {
                content: '开发中',
            },
        },
        {
            path: 'online',
            name: 'OnlineTools',
            component: LAYOUT,
            redirect: '/tools/online/form',
            meta: {
                title: t('routes.demo.tools.online.moduleName'),
                icon: 'material-symbols:cloud-done-outline-sharp',
            },
            children: [
                {
                    path: 'form',
                    name: 'OnlineFormTools',
                    meta: {
                        title: t('routes.demo.tools.online.form'),
                        icon: 'fluent:form-20-regular',
                    },
                    component: () => import('/@/views/demo/tools/online/form/index.vue'),
                    tag: {
                        content: '开发中',
                        background: '#f50',
                    },
                },
                {
                    path: 'report',
                    name: 'OnlineReportTools',
                    meta: {
                        title: t('routes.demo.tools.online.report'),
                        icon: 'carbon:report',
                    },
                    component: () => import('/@/views/demo/tools/online/report/index.vue'),
                },
                {
                    path: 'chart',
                    name: 'OnlineChartTools',
                    meta: {
                        title: t('routes.demo.tools.online.chart'),
                        icon: 'ic:baseline-bar-chart',
                    },
                    component: () => import('/@/views/demo/tools/online/chart/index.vue'),
                },
            ],
        },
        {
            path: 'doc',
            name: 'DocTools',
            component: LAYOUT,
            redirect: '/tools/doc/api',
            meta: {
                title: t('routes.demo.tools.doc.moduleName'),
                icon: 'iconoir:doc-search-alt',
            },
            children: [
                {
                    path: 'api',
                    name: 'DocApiTools',
                    meta: {
                        title: t('routes.demo.tools.doc.api'),
                        icon: 'ant-design:api-outlined',
                    },
                    component: () => import('/@/views/demo/tools/doc/api/index.vue'),
                },
                {
                    path: 'database',
                    name: 'DocDatabaseTools',
                    meta: {
                        title: t('routes.demo.tools.doc.database'),
                        icon: 'mdi:database-eye-outline',
                    },
                    component: () => import('/@/views/demo/tools/doc/database/index.vue'),
                },
            ],
        },
    ],
}

export default tools
